import axios from "axios";

export interface LoginResponse {
    user: string,
    roles: string 
}

export interface EmailLoginInitResponse {
    timestamp: number,
    c2: string 
}

export async function login(email?: string, password?: string): Promise<LoginResponse> {
    if (email && password) {
        return axios.get("/api/login", {
            auth: {username: email, password: password},
            headers: { Accept: "application/json",}
        }).then((r) => {
            return r.data as LoginResponse;
        })
    }
    else {
        return axios.get("/api/login", {
            withCredentials: true, // Automatically send cookies
            headers: {Accept: "application/json",}
        }).then((r) => {
            return r.data as LoginResponse;
        })
    }
}

export async function initiateEmailLogin(email: string, topic?: string): Promise<EmailLoginInitResponse> {
    const emailUrlEncoded = encodeURIComponent(email);
    const topicUrlEncoded = topic ? encodeURIComponent(topic) : null;
    const url = topicUrlEncoded ? `/api/user/tpc/${emailUrlEncoded}?topic=${topicUrlEncoded}` : `/api/user/tpc/${emailUrlEncoded}`;
    return axios.get(url).then((r) => {return r.data as EmailLoginInitResponse;});
}

export async function completeEmailLogin(email: string, c1: string, c2: string, timestamp: number, override?: boolean) : Promise<LoginResponse> {
    const headers = override ? 
            { 
                "accept": "application/json", 
                "x-email-header": email,
                "x-email-verify-c1-header" : c1,
                "x-email-verify-c2-header" : c2,
                "x-email-verify-timestamp" : timestamp,
                "x-email-auth-override" : true
            }
     :
            { 
                "accept": "application/json", 
                "x-email-header": email,
                "x-email-verify-c1-header" : c1,
                "x-email-verify-c2-header" : c2,
                "x-email-verify-timestamp" : timestamp,
            };
        return axios.get("/api/login", {
            headers: { 
                ...headers
            }
        }).then((r) => {
            return r.data as LoginResponse;
        })
}

export async function logout() {
    return axios.get("/api/logout");
}

export async function signup(username: string, password: string) {
    const signupRequestBody = {
        requestedRole: "USER",
        password: password,
        email: username,
        verificationUrl: `https://${window.location.hostname}/signup/verify`, // + "?code=......." is added in the backend
    };
    return axios.post("/api/user", signupRequestBody).then((r) => {return r.data as string;})
}

export async function changePassword(username: string, password: string) {
    const signupRequestBody = {
        requestedRole: "USER",
        password: password,
        email: username,
        verificationUrl: `https://${window.location.hostname}/passwordchange/verify`, // + "?code=......." is added in the backend
    };
    return axios.put("/api/user", signupRequestBody).then((r) => {return r.data as string;})
}

export async function userVerify(code: string, password: string) {
    return axios.post(`/api/user/verify`, 
        null, 
        {params: {code, password}}
    ).then((r) => {return r.data as string;});
}

export async function passwordChangeVerify(code: string, password: string) {
    return axios.post(`/api/user/passwordchange/verify`, 
        null, 
        {params: {code, password}}
    ).then((r) => {return r.data as string;});
}